// TODO: Remove old 'TableComponents' component and let these components take their place

import styled from 'styled-components';
import { Fonts, Palette } from '../utils';
import { CDropdownItem, CDropdownMenu, CDropdownToggle } from '@coreui/react';
import { Separator } from '../ui/Separator';
import { IoIosSearch } from 'react-icons/io';
import { IoCloseCircleOutline } from 'react-icons/io5';
import { Dropdown } from 'antd';
import { CustomDatePicker } from '../CustomSearchBar';
import { FiSearch } from 'react-icons/fi';

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const HeaderMenu = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const HeaderTitle = styled.p`
  color: ${Palette.BLACK};
  text-align: center;

  font-family: ${Fonts.RED_HAT_FONT};
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 800;
  line-height: 2.5rem;
  margin: 0;
`;

export const HeaderButtonContainer = styled.div`
  display: flex;
  gap: 16px;
`;

export const SearchContainer = styled.div`
  display: flex;
  padding: 0.75rem 1.125rem;
  height: 68px;

  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;

  border-radius: 10px;
  background: ${Palette.GREY_100};
`;

export const StyledDropdown = styled(CDropdownMenu)`
  width: 388px;
  padding: 18px;
  flex-direction: column;
  align-items: flex-end;

  border-radius: 10px;
  border: 0.5px solid rgba(0, 0, 0, 0.1);

  background: #f8f8fa;

  box-shadow: 1px 1px 25px 0px rgba(0, 0, 0, 0.1);
`;

export const StyledDropdownToggle = styled(CDropdownToggle)`
  display: flex;
  min-width: 200px;
  padding: 10px;
  justify-content: space-between;
  align-items: flex-start;

  box-shadow: none !important;
  border-radius: 8px;
  background: ${Palette.WHITE};

  color: ${Palette.BLACK_50};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const NewStyledDropdownToggle = styled.div`
  display: flex;
  min-width: 200px;
  padding: 10px;
  justify-content: space-between;
  align-items: flex-start;

  box-shadow: none !important;
  border-radius: 8px;
  background: ${Palette.WHITE};

  color: ${Palette.BLACK_50};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  :hover {
    cursor: pointer;
  }
`;

export const DropdownFilter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DropdownFilterTitle = styled.p`
  color: ${Palette.BLACK};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
`;

export const DropdownFilterContainer = styled.div`
  display: flex;
  gap: 8px;
  ${({ wrap }) => (wrap ? 'flex-wrap: wrap;' : 'flex-wrap: none;')}
`;

export const DropdownFilterSeparator = styled(Separator)`
  margin: 24px 0;
`;

export const FilterDateSelector = styled(CustomDatePicker)`
  padding: 6px 10px;
  border-radius: 5px;
  background-color: ${Palette.WHITE} !important;

  .ant-picker-input {
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
  }

  input {
    color: ${Palette.BLACK_50};
    font-family: ${Fonts.OPEN_SANS_FONT};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;

    order: 2;
  }

  .ant-picker-suffix {
    margin-left: 0;
  }
`;

export const SearchIcon = styled(FiSearch)`
  position: absolute;
  left: 15px;
  top: 27%;
  color: ${Palette.CONTENT_TERTIARY};
`;

export const SearchCloseIcon = styled(IoCloseCircleOutline)`
  position: absolute;
  right: 15px;
  top: 30%;
  color: ${Palette.CONTENT_TERTIARY};

  :hover {
    ${(props) => (props.disabled ? `cursor: not-allowed;` : `cursor: pointer;`)};
  }

  :disabled {
    :hover {
      cursor: not-allowed;
    }
  }
`;

export const FilterBadge = styled.p`
  display: flex;
  width: 20px;
  height: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  border-radius: 100%;
  background: ${Palette.HAZY_BLUE};

  color: ${Palette.WHITE};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 9.412px;
  font-style: normal;
  font-weight: 600;
  line-height: 28.235px;

  margin: 0;
`;

export const CSVDropdown = styled(Dropdown)`
  display: flex;
  min-width: 160px;
  padding: 10px 26px;
  justify-content: space-between;
  align-items: center;

  border: 1px solid ${Palette.HAZY_BLUE};
  border-radius: 100px;
  background: ${Palette.GHOST_WHITE};

  color: ${Palette.HAZY_BLUE};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;

  animation-duration: 0s !important;
  transition: none !important;

  &.ant-dropdown-open {
    border-radius: 22px 22px 0px 0px;
  }

  ${({ cssOverride }) => cssOverride};
`;

export const DropdownWrapper = styled.div`
  .ant-dropdown-menu {
    box-shadow: none;
    min-width: 160px;
    gap: 6px;
    padding: 8px 26px 16px 26px;
    border-radius: 0px 0px 30px 30px;
    border: 1px solid ${Palette.HAZY_BLUE};
    background: ${Palette.GHOST_WHITE};
    transition: none !important;
  }

  .ant-dropdown-menu-item {
    padding: 0;
    transition: none;

    :hover {
      color: inherit;
      text-decoration: underline;
    }
  }
`;

export const DropdownTitleText = styled.p`
  color: ${Palette.DARK_ASH};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
`;

export const StyledCDropdownItem = styled(CDropdownItem)`
  padding: 0 !important;
  margin: 0 !important;
  display: inline-block !important;
  width: auto !important;
  height: auto !important;

  > button {
    width: 100%;
    height: 100%;
  }

  :hover {
    background-color: transparent;
  }

  :active {
    background-color: transparent;
  }
`;

export const NewStyledCDropdownItem = styled.div`
  padding: 0 !important;
  margin: 0 !important;
  display: inline-block !important;
  width: auto !important;
  height: auto !important;

  > button {
    width: 100%;
    height: 100%;
  }

  :hover {
    background-color: transparent;
  }

  :active {
    background-color: transparent;
  }
`;

// Tabs
export const TabList = styled.div`
  display: inline-flex;
  padding: 5px 7px;
  align-items: center;
  gap: 10px;
  width: fit-content;

  border-radius: 10px;
  background: ${Palette.GHOST_WHITE};
`;

export const Tab = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  padding: 8px 0;
  min-width: 100px;
  gap: 10px;
  flex-shrink: 0;
  border: none;

  ${(props) =>
    props.isActive
      ? `background: ${Palette.HAZY_BLUE}; box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25)`
      : `background: ${Palette.GHOST_WHITE};`};

  &:focus {
    outline: none;
  }
`;

export const StyledTabLabel = styled.span`
  ${(props) => (props.isActive ? `color: ${Palette.WHITE_SMOKE};` : `color: ${Palette.DARK_ASH};`)};

  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;
